package com.anjuros.website.redesign.sections.seo

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdClosingCard
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

@Composable
fun SeoClosingSection() {
    RdClosingCard(
        RdText.SEO_CLOSE_EYEBROW, RdText.SEO_CLOSE_TITLE, RdText.SEO_CLOSE_LEDE,
        secondaryText = RdText.CTA_SEE_ALL_DESIGNS, secondaryPath = RdRoute.DESIGNS,
    )
}
